<div class="surveyClosedCont">
    <div data-test-id="surveyCloseHeader" class="header">
        <div class="warnBg"></div>
        <div class="warnMsg" i18n="Survey Closed|Questionnaire period has passed or has ended and no more results accepted@@surveyClosedHeaderMessage">
           This survey has been closed!
        </div>
    </div>

    <div data-test-id="surveyCloseBody" class="bodyMsg" i18n>
        Thank you for trying to participate but it looks like the survey has been closed by its owner already. We apologize for any inconvenience this may have caused. We appreciate your interest in assisting us by sharing your insights.
    </div>
</div>